import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { GroundResistanceMeasure } from "../../../models/schemas/measures/electrical.schema";
import { GROUND_RESISTANCE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 접지저항 컨트롤러
 * 판정 기준:
 * - <= GROUND_RESISTANCE_THRESHOLDS.good (10Ω): GOOD
 * - <= GROUND_RESISTANCE_THRESHOLDS.caution (100Ω): CAUTION
 * - > 100Ω: BAD
 */
export class GroundResistanceController extends MeasureController<GroundResistanceMeasure> {
  protected getDefaultData(): GroundResistanceMeasure {
    return {
      label: "",
      method: "",
      measuredValue: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { measuredValue } = this.data;

    // 데이터 미입력 시
    if (measuredValue === undefined || measuredValue === null || measuredValue === 0) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // 판정: <= GOOD (10Ω), <= CAUTION (100Ω), > 100Ω (BAD)
    let result: JudgmentResultType;
    if (measuredValue <= GROUND_RESISTANCE_THRESHOLDS.good) {
      result = "GOOD";
    } else if (measuredValue <= GROUND_RESISTANCE_THRESHOLDS.caution) {
      result = "CAUTION";
    } else {
      result = "BAD";
    }

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return "접지저항이 10Ω 이하로 우수";
    }
    if (result === "CAUTION") {
      return "접지저항이 10Ω 초과 100Ω 이하로 주의 필요";
    }
    return "접지저항이 100Ω 초과로 불량. 즉시 점검 필요";
  }
}
